import { controls } from "../../controls";

const rp441 = {
  label: "N.O.D.C",
  pageLabel: "MONTHLY LOAN TRANSACTION STATEMENT (NODC)",
  starting: true,
  url: "rp441",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "Product Code", star: true, width: "col-sm-2" }),
    ...controls.product({ tab: "filter" }),
    ...controls.showData({ tab: "filter", isRequired: true, data: "product_code_display", name: "product_code_display", width: "col-sm-2", displaytype: 'camelcase' }),

    ...controls.displayText({ tab: "filter", label: "From Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "from_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "To Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "to_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "MONTHLY LOAN TRANSACTION STATEMENT (NODC)",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Branch Code",
        accessor: "code",
        width: 70,
        rwidth: 30
      },
      {
        Header: "Acct No.",
        accessor: "AcctCode",
        width: 140,
        rwidth: 60
      },
      {
        Header: "Name Of Society",
        accessor: "descn",
        width: 200,
        rwidth: "*"
      },
      {
        Header: "Audit Class",
        accessor: "auditclass",
        width: 50,
        rwidth: 25
      },
      {
        Header: "Demand",
        accessor: "demand",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Opening Balance",
        accessor: "opbal",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Advance from",
        columns: [
          {
            Header: "Net",
            accessor: "Net",
            type: "currency",
            rwidth: 50
          },
          {
            Header: "Trf",
            accessor: "trf",
            type: "currency",
            rwidth: 30
          },
          {
            accessor: "Total",
            Header: "Total",
            type: "currency",
            rwidth: 50
          }
        ]
      },
      {
        Header: "Recovery from",
        columns: [
          {
            Header: "Net",
            accessor: "NetR",
            type: "currency",
            rwidth: 50
          },
          {
            Header: "Future",
            accessor: "future",
            type: "currency",
            rwidth: 50
          },
          {
            Header: "Trf",
            accessor: "trfR",
            type: "currency",
            rwidth: 30
          },
          {
            Header: "Total",
            accessor: "TotalR",
            type: "currency",
            rwidth: 50
          }
        ]
      },
      {
        Header: "Outstanding",
        accessor: "clsbal",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Overdues",
        accessor: "ovd",
        type: "currency",
        rwidth: 50
      },
      {
        Header: "Interest Received",
        accessor: "intReceived",
        type: "currency",
        rwidth: 25
      }
    ]
  }
};

export default rp441;